<div class="flex h-dvh flex-col overflow-hidden bg-[#0d0d16] text-slate-100">
  <app-top-bar />
  <main class="flex min-h-0 flex-1 flex-col-reverse landscape:flex-row">
    <app-toolbar />
    <div class="relative flex min-h-0 min-w-0 flex-1 flex-col">
      <app-status-strip />
      <app-game-canvas class="block h-full w-full min-h-0" />
      <app-subscription-error-banner />
      <app-zoom-controls />
    </div>
    @if (ui.rxSidebarOpen()) {
      <app-rx-sidebar />
    }
  </main>
  <app-footer />
</div>
<app-coach-mark />
@defer (on idle) {
  <app-function-picker />
  <app-machine-arg-picker />
  <app-observable-arg-picker />
  <app-subscriber-destroy-control />
}
@defer (on idle) {
  @if (ui.tutorialLogOpen()) {
    <app-tutorial-log />
  }
}
@defer (on idle) {
  @if (ui.recipesModalOpen()) {
    <app-recipes-modal />
  }
}
